import React from "react";
import { useTranslator } from "../../context/translator";

const FormError = ({ form, name }) => {
  const { translate } = useTranslator();
  if (!form || !form[name]) return null;

  const message = translate ? translate(form[name]) : form[name];

  return <label className="text-red-500 text-sm mt-1 block">{message}</label>;
};

export default FormError;
